import React from "react";
import PropTypes from "prop-types";
import { Container, Box } from "@material-ui/core";
import clsx from "classnames";
import { useStyles } from "../../hooks";
import styles from "./styles";

const BoxContainer = ({ children, margen = false }) => {
  const classes = useStyles(styles);

  return (
    <Container className={clsx(margen ? classes.altura : classes.alturaOriginal)}>
     
      <Box className={clsx(margen ? classes.root2 : classes.root)}>{children}</Box>
    </Container>
  );
};

BoxContainer.propTypes = {
  children: PropTypes.node.isRequired
};

export default BoxContainer;
